// extracted by mini-css-extract-plugin
export default {"bodyWrap":"ReviewComplete_bodyWrap__mc55Q","body":"ReviewComplete_body__d40gG","logo":"ReviewComplete_logo__GZ0iq","title":"ReviewComplete_title__+L5GO"};